
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/network/mint",
      function () {
        return require("private-next-pages/network/mint.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/network/mint"])
      });
    }
  